export const environment = {
  production: true,
  graphql: {
    uri: 'https://api.iqd-pro.com/graphql',
  },
  sentry: {
    dsn: 'https://8ee1b4a1c0207648be1690a6757d4c3c@o4509351712194560.ingest.de.sentry.io/4512022268149840',
    enabled: true,
  },
  gtm: {
    id: 'GTM-WH899QZ6',
    enabled: true,
  },
};
